import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { useInView } from 'react-intersection-observer';
import 'animate.css';
import { animationClass, animationStyle } from '../../../utils/FadeInEffect';
import { SOURCE_URL } from '../../../config';

interface BusinessSplitTemplateProps {
    element: any
}

const BusinessSplitTemplate: React.FC<BusinessSplitTemplateProps> = (element) => {

    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });


    return (
        <>  
        <section className="split-template">
		    <div className="row no-gutters">
                {Array.isArray(element?.element?.Banners) && element?.element?.Banners?.map((item: any,index: number)=>(
                    <div key={index} className="col-lg-6 hid-overflow" style={{background: "url(" + SOURCE_URL + item?.BackgroundImage?.data?.attributes?.url + ")" + item?.BackgroundImagePosition?.replace(" - ", " ").toLowerCase() +" / cover"}}>
                        <div className="h-100 d-flex justify-content-between flex-column">
                            <div ref={ref} className={`pt-5 ${item?.TextColor?.toLowerCase()} text-${item?.TextPosition?.toLowerCase()} pxc ${animationClass(inView,'left')}`} style={animationStyle(inView, 'left')}>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item?.Text}</ReactMarkdown>
                                <img className="channel-logo mb-4 d-block lazyloaded" src={SOURCE_URL + item?.ChannelLogo?.data?.attributes?.url} />
                                <a href={item?.ButtonLinkURL} className="default-btn" target={item?.OpenLinkInANewTab ? '_blank' : '_self'} id="">{item?.ButtonLinkText}</a>
                            </div>
                            <img ref={ref}  src={SOURCE_URL + item?.BottomImage?.data?.attributes?.url} className={`w-100 d-block bottom-img lazyloaded ${animationClass(inView, 'up')}`} style={animationStyle(inView,'up')} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
        </>
    );
}
export default BusinessSplitTemplate;